// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsScratchAndDentCarouselProductStyles } from "@plumberssupply/App/Components/ProductDetails/ProductDetailsScratchAndDentCarouselProduct";
import { primaryImageStyles } from "@plumberssupply/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { ellipsis } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

productDetailsScratchAndDentCarouselProductStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 80px 1fr;
        grid-template-rows: 1fr auto;
        grid-column-gap: 12px;
        grid-row-gap: 0;
        height: 100%;
    `,
};

productDetailsScratchAndDentCarouselProductStyles.imageContainer = {
    css: css`
        grid-area: 1/ 1 / 1 / 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};

productDetailsScratchAndDentCarouselProductStyles.infoContainer = {
    css: css`
        grid-area: 1 / 2;
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};

productDetailsScratchAndDentCarouselProductStyles.productInfoContainer = {
    css: css`
        display: flex;
    `,
};

productDetailsScratchAndDentCarouselProductStyles.productBrandStyles = {
    nameLink: {
        css: css`
            margin-bottom: 0;
        `,
    },
};

productDetailsScratchAndDentCarouselProductStyles.productDescriptionStyles = {
    productDetailLink: {
        typographyProps: {
            lineHeight: "16px",
            css: css`
                min-height: 54px;
                ${ellipsis(3)}
            `,
        },
    },
};

productDetailsScratchAndDentCarouselProductStyles.infoLabel = {
    weight: "bold",
    size: 12,
    lineHeight: "15px",
    css: css`
        margin-right: 4px;
    `,
};

productDetailsScratchAndDentCarouselProductStyles.infoValue = {
    size: 12,
    lineHeight: "15px",
    css: css`
        ${ellipsis(1)};
    `,
};

productDetailsScratchAndDentCarouselProductStyles.price = {
    size: 22,
    css: css`
        margin-top: auto;
        margin-bottom: 5px;
    `,
};

productDetailsScratchAndDentCarouselProductStyles.productAddToCartButtonStyles = {
    css: css`
        height: 28px;
        font-size: 11px;
        padding: 0;
        min-width: 96px;
        width: 180px;
    `,
};

productDetailsScratchAndDentCarouselProductStyles.actionContainer = {
    css: css`
        grid-area: 2 / 1 / 2 / 3;
        display: flex;
    `,
};

productDetailsScratchAndDentCarouselProductStyles.viewGallery = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
        color: "secondary",
    },
    css: css`
        justify-content: center;
    `,
};

productDetailsScratchAndDentCarouselProductStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 80px;
            height: 80px;
            margin-right: 20px;
            margin-bottom: 4px;
        `,
    },
    img: {
        css: css`
            max-width: 100%;
            max-height: 100%;
            height: auto;
            object-fit: contain;
        `,
    },
};

productDetailsScratchAndDentCarouselProductStyles.primaryImageStyles = {
    ...primaryImageStyles,
};
